import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  Typography,
  TextField,
  Card,
  DialogContentText,
} from "@mui/material";
import { Edit, Delete, Add, Save, Close } from "@mui/icons-material";
import {
  getGroupsByUser,
  createGroup,
  deleteGroup,
  renameGroup,
} from "../../services/Groups";

export default function GroupManager() {
  const [groups, setGroups] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [groupId, setGroupId] = useState(null);
  const [groupName, setGroupName] = useState("");

  useEffect(() => {
    getGroups();
  }, []);

  const getGroups = () => {
    getGroupsByUser()
      .then((response) => {
        setGroups(response.data);
      })
      .catch((error) => {
        //
      });
  };

  const handleOpenDeleteModal = (id, name) => {
    setGroupId(id);
    setGroupName(name);
    setOpenDeleteModal(true);
  };

  const handleOpenEditModal = (id, name) => {
    setGroupId(id);
    setGroupName(name);
    setOpenEditModal(true);
  };

  const handleCloseModal = () => {
    setGroupName("");
    setGroupId(null);
    setOpenEditModal(false);
    setOpenDeleteModal(false);
    setOpenCreateModal(false);
  };

  const handleCreateGroup = () => {
    createGroup({ groupName: groupName })
      .then(() => {
        getGroups();
      })
      .catch((error) => {
        //console.error("Error creating group:", error);
      });
    handleCloseModal();
  };

  const handleRenameGroup = () => {
    renameGroup({ groupId: groupId, groupName: groupName })
      .then(() => {
        getGroups();
      })
      .catch((error) => {
        // Handle error
      });
    handleCloseModal();
  };

  const handleDeleteGroup = () => {
    deleteGroup({ groupId: groupId })
      .then(() => {
        getGroups();
      })
      .catch((error) => {
        // Handle error
      });
    handleCloseModal();
  };

  return (
    <Box p={1} sx={{ textAlign: "center" }}>
      <List>
        {groups &&
          groups.map(
            (item) =>
              item.name !== "__dg_" && (
                <Card key={item.id} sx={{ mb: 1, p: 1 }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography>{item.name}</Typography>
                    <Box>
                      <IconButton
                        onClick={() => handleOpenEditModal(item.id, item.name)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          handleOpenDeleteModal(item.id, item.name)
                        }
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </Box>
                </Card>
              ),
          )}
      </List>

      <Button
        variant="contained"
        onClick={() => setOpenCreateModal(true)}
        startIcon={<Add />}
      >
        Adicionar Grupo{/*trad */}
      </Button>

      <Dialog open={openEditModal} onClose={handleCloseModal}>
        <DialogTitle>Renomear Grupo{/*trad */}</DialogTitle>
        <Box mt={1}>
          <DialogContent>
            <TextField
              autoFocus
              label="Nome do Grupo" /*trad */
              fullWidth
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCloseModal()} startIcon={<Close />}>
              Cancelar{/*trad */}
            </Button>
            <Button
              onClick={() => handleRenameGroup()}
              variant="contained"
              startIcon={<Save />}
              disabled={!groupName.trim()} // Minimum length check
            >
              Salvar{/*trad */}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <Dialog open={openCreateModal} onClose={handleCloseModal}>
        <DialogTitle>{"Novo Grupo" /*trad */}</DialogTitle>
        <Box mt={1}>
          <DialogContent>
            <TextField
              autoFocus
              label="Nome do Grupo" /*trad */
              fullWidth
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => handleCloseModal()} startIcon={<Close />}>
              Cancelar{/*trad */}
            </Button>
            <Button
              onClick={() => handleCreateGroup()}
              variant="contained"
              startIcon={<Save />}
              disabled={!groupName.trim()}
            >
              Salvar{/*trad */}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <DialogTitle>Exclusão de grupo {/* trad */}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja excluir o grupo "<b>{groupName}</b>"?
            <Box>
              <Typography variant="caption">
                Os layouts associados NÃO SERÃO EXCLUÍDOS.
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseModal()} startIcon={<Close />}>
            Cancelar{/*trad */}
          </Button>
          <Button variant="contained" onClick={() => handleDeleteGroup()}>
            Excluir{/* trad */}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
